import isEmpty from 'lodash.isempty';

import { connectedStore } from '../../store';
import constants from '../constants';
import globals from '../../globals';
import getFontPair from '../selectors/font-pair';
import template from '../../template';

const getCurrentFontPair = () => {
  const store = connectedStore.get();
  const state = store.getState();

  const fontVariables = template.selectors.getVariableValueByPath(state, constants.FONTS_VARIABLE);

  if (isEmpty(fontVariables)) return null;

  const variable = fontVariables.find((item) => item.querySelector);

  if (!variable) return null;

  const globalNode = globals.operations.extractGlobalContent('header-code');
  if (!globalNode) return null;

  const element = globalNode.querySelector(variable.querySelector);
  if (!element) return null;

  const currentFontPairId = element.getAttribute(constants.FONTS_DATA_ATTRIBUTE);

  return getFontPair(state, currentFontPairId);
};

export default getCurrentFontPair;
